import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

import { SettingsService } from '@app/core/settings/services/settings.service';
import { EFeatureFlag } from '@app/feature-toggle-list';
import { FeatureToggleService } from '@app/shared/services/feature-toggle.service';

@Injectable({
  providedIn: 'root',
})
export class LotTrackingService {
  constructor(
    private settingsService :SettingsService,
    private feaureToggleService :FeatureToggleService,
  ) {}

  checkLotTrackingEnabled() :Observable<boolean> {
    return this.settingsService.getKeyValue('track_inventory_by_location').pipe(
      map((value) => {
        if (
          value &&
          this.feaureToggleService.featureEnabled(EFeatureFlag.LOT_TRACKING)
        ) {
          return true;
        }

        return false;
      }),
    );
  }
}
